import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import axiApi from "ApiCaller";
import TableIslands from "./islands/TableIslands";
import ButtonsActions from "views/utils/buttonsActions";
import TopBarActions from "components/TopBarActions";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";

import ItemsModel from "core/itemsModel";

const buttonsActions = new ButtonsActions();

const ViewIslands = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tt} = useTranslation("tables");

    const title = _Tr("labels.island");

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [itemsShown, setItemsShown] = useState([]);
    const [buttonsTB, setButtonsTB] = useState(buttonsActions);
    const bread = [
        {name: _Tr("labels.data-view"), url: "/data-view/", current: false},
        {name: title, current: true},
    ];

    const headersTable = [{name: _Tt("routes.name"), attr: 0, direction: "asc", active: true, default: true}];

    useEffect(() => {
        const buttons = {...buttonsActions};
        buttons.title = title;
        setButtonsTB(buttons);
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchIslands();
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => fetchIslands();
        const fetchGetIslands = () => {
            axiApi.get(`/api/distribution/islands/`).then((resp) => {
                items.current.all = [...resp.data.items];
                items.current.showed = [...resp.data.items];
                setItemsShown([...resp.data.items]);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            });
        };
        fetchGetIslands();
    }, []);

    function clickCheckRow(e) {
        console.log(e.target);
        console.log(e.currentTarget);
    }

    filters.current.filter = () => fetchIslands();

    const fetchIslands = () => {
        axiApi
            .post("/api/distribution/islands/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                items.current.all = [...resp.data.items];
                items.current.showed = [...resp.data.items];
                setItemsShown([...resp.data.items]);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" />

            <div className="row">
                <div className="col-12">
                    <div className="col-md col-12">
                        <LoaderSpinner isLoading={false}>
                            <TableIslands itemsShown={itemsShown} onClickRow={clickCheckRow} orderingRef={orderingRef} />
                        </LoaderSpinner>
                    </div>
                </div>
            </div>
        </>
    );
};
export default ViewIslands;
